(() => {
  const selector = '.product__wrapper--grid-2';
  let paymentScrubQueued = false;

  function scrubPaymentArtifacts(root = document) {
    root.querySelectorAll('.shopify-payment-button__more-options').forEach((element) => element.remove());
  }

  function queuePaymentScrub() {
    if (paymentScrubQueued) return;
    paymentScrubQueued = true;
    requestAnimationFrame(() => {
      paymentScrubQueued = false;
      scrubPaymentArtifacts();
    });
  }

  function enhance(root = document) {
    root.querySelectorAll(selector).forEach((wrapper) => {
      if (wrapper.dataset.ssGalleryReady === 'true') return;

      const slides = wrapper.querySelector('.product__slides');
      if (!slides) return;

      const items = Array.from(slides.querySelectorAll(':scope > .product__slide'));
      if (items.length <= 4) {
        wrapper.dataset.ssGalleryReady = 'true';
        return;
      }

      items.slice(4).forEach((item) => item.classList.add('ss-gallery-extra'));

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ss-gallery-view-all';
      button.textContent = 'View all';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', `View all ${items.length} product images`);

      button.addEventListener('click', () => {
        items.forEach((item) => item.classList.remove('ss-gallery-extra'));
        wrapper.classList.add('ss-gallery-expanded');
        button.setAttribute('aria-expanded', 'true');
        button.remove();
      });

      slides.insertAdjacentElement('afterend', button);
      wrapper.dataset.ssGalleryReady = 'true';
    });
  }

  function initialise() {
    enhance();
    scrubPaymentArtifacts();

    const paymentObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === 'childList')) queuePaymentScrub();
    });

    paymentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.addEventListener('scroll', queuePaymentScrub, { passive: true });
    window.addEventListener('resize', queuePaymentScrub, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => {
    enhance(event.target);
    queuePaymentScrub();
  });
})();
